
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
// nodejs library that concatenates classes
import classnames from "classnames";
import { createUsers } from "api/usersApiCall";

// javascript plugin that creates nice dropzones for files
import Dropzone from "dropzone";
// reactstrap components
import {
  UncontrolledAlert,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";



// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { useTranslation } from '../../../i18n/context';


Dropzone.autoDiscover = false;

function AddUser() {
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const [yourName, setyourName] = React.useState(false);
  const [emailAddress, setemailAddress] = React.useState(false);
  const [password, setpassword] = React.useState(false);
  const [phoneNumber, setphoneNumber] = React.useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const { t } = useTranslation();



  const toggleSidenav = (e) => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    user_email: '',
    user_phone: '',
    password: ''
  });
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const [errorUsersCall, successUserCall] = await createUsers(formData);
    if (errorUsersCall || !successUserCall) {
      setError(errorUsersCall);
      setShowErrorAlert(true);
    } else {
      setShowSuccessAlert(true);
      setTimeout(() => {
        navigate('/admin/users');
      }, 2000)
    }
  };


  return (
    <>
      <SimpleHeader name="Add User" />

      <Container className="mt--6" fluid>
        <Row>
          <Col lg="12">
            <div className="card-wrapper">

              <Card>
                <CardHeader>
                  <h3 className="mb-0">{t('profile.adduser')}</h3>
                  {showSuccessAlert && (
                    <UncontrolledAlert color="success">
                      <span className="alert-icon">
                        <i className="ni ni-like-2" />
                      </span>
                      <span className="alert-text ml-1">
                        <strong>{t('common.success')}</strong> {t('profile.successful')}
                      </span>
                    </UncontrolledAlert>
                  )}

                  {showErrorAlert && (
                    <UncontrolledAlert color="danger">
                      <span className="alert-icon">
                        <i className="ni ni-support-16" />
                      </span>
                      <span className="alert-text ml-1">
                        <strong>{t('common.error')}</strong> {t('profile.not_successful')}
                      </span>
                    </UncontrolledAlert>
                  )}
                </CardHeader>

                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <InputGroup
                            className={classnames("input-group-merge", {
                              focused: yourName,
                            })}
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fas fa-user" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder={t('profile.name')}
                              type="text"
                              name="username"
                              id="username"
                              value={formData.username}
                              onChange={handleInputChange}
                              required
                              onFocus={(e) => setyourName(true)}
                              onBlur={(e) => setyourName(false)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <InputGroup
                            className={classnames("input-group-merge", {
                              focused: emailAddress,
                            })}
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fas fa-envelope" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Email"
                              type="email"
                              name="user_email"
                              id="user_email"
                              value={formData.user_email}
                              onChange={handleInputChange}
                              required
                              onFocus={(e) => setemailAddress(true)}
                              onBlur={(e) => setemailAddress(false)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <InputGroup
                            className={classnames("input-group-merge", {
                              focused: phoneNumber,
                            })}
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fas fa-phone" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder={t('profile.phone')}
                              type="text"
                              name="user_phone"
                              id="user_phone"
                              value={formData.user_phone}
                              onChange={handleInputChange}
                              required
                              onFocus={(e) => setphoneNumber(true)}
                              onBlur={(e) => setphoneNumber(false)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <InputGroup
                            className={classnames("input-group-merge", {
                              focused: password,
                            })}
                          >
                            <InputGroupAddon addonType="append">
                              <InputGroupText>
                                <i className="fas fa-eye" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder={t('common.password')}
                              type="password"
                              name='password'
                              id='password'
                              value={formData.password}
                              onChange={handleInputChange}
                              onFocus={(e) => setpassword(true)}
                              onBlur={(e) => setpassword(false)}
                            />

                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button className="btn-icon" color="primary" type="submit">
                      <span className="btn-inner--text">{t('profile.submit')}</span>
                    </Button>
                  </Form>
                </CardBody>
              </Card>

            </div>
          </Col>

        </Row>
      </Container>
      {sidenavOpen ? (
        <div className="backdrop d-xl-none" onClick={toggleSidenav} />
      ) : null}
    </>
  );
}

export default AddUser;
